export default __webpack_public_path__ + "static/media/image7.49074cd6.jpg";